import { PropertyRule } from '@aurelia/validation';

// The validator throws for a condition that returns anything but true or false. The conditions in the forms
// return whatever their expression does (`(v) => v && v > -1`), and a falsy value has always meant "invalid".
const satisfies = PropertyRule.prototype.satisfies;

PropertyRule.prototype.satisfies = function (condition) {
  return satisfies.call(this, (value, object) => {
    const satisfied = condition(value, object);
    return satisfied instanceof Promise ? satisfied.then(Boolean) : Boolean(satisfied);
  });
};
